/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FlagMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGElEQVR4nO2VzUoDMRSF5w1cWFD7NkVXMvdnhPSeIm51pS58BsEH6EJfxkVbH0a03YoojGSGwoiJnXTQ1Ry4q0zul0xyTrLsv0SKJxabh8aK4vSAeXzEBa5IbMqKOyLsJQFYUfrKxQ6rRmr3Hshqq/VYs0jxuBWgbZHgM9Tn2Ll959xOZwA3dsuKh+ZuSfBOauedAfxr2csfA1D2gLL/ReVPc9kriT13vkUkWJJi5uOCBJfeUOvsIcFNS6cvgwBv9Wic8HjEYm8tAB8ik4sgINac1E78xIBjVyxYVHGhdu1TV/VsN5pFMUCeTwasuK3jum7EjGHs+2RAZ6UCyD9Qm86i+YClAriK5w03STHbGpAsv6JvxF5ZrS8qE0gpkcBgwwAAAABJRU5ErkJggg==)
 */
export const FlagMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 2a1 1 0 0 0-2 0v19a1 1 0 1 0 2 0v-6.82l8.2-1.37c.37-.06.65.28.47.6a5.01 5.01 0 0 1-1.94 1.94c-.26.14-.38.47-.18.68a2 2 0 0 0 1.78.6l9-1.5A2 2 0 0 0 23 13.15v-7.3a2 2 0 0 0-2.33-1.98L15 4.82V3.35a2 2 0 0 0-2.33-1.98L4 2.82V2ZM15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
